
export default {
  name: 'TPBlock',
  props: {
    number: String,
    info: Object,
  },
}
